import React, { cloneElement } from "react";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useAsyncDebounce,
} from "react-table";
import { matchSorter } from "match-sorter";
import ReactHtmlParser from "react-html-parser";

function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <span className="flex justify-between tracking-wide text-center text-gray-900 bg-gray-100 border-b-2 border-gray-600 item text-md">
      <div className="flex items-center justify-center min-h-full ml-2">
        Search:{" "}
      </div>
      <input
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={`${count} records...`}
        className="px-4 py-2 my-2 mr-2 rounded focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
      />
    </span>
  );
}

export function fuzzyTextFilterFn(rows, id, filterValue) {
  console.log(
    rows.map((row) =>
      row.original.elements.map(
        (row, index) => row.original.elements[index].value
      )
    )
  );
  return matchSorter(rows, filterValue, {
    keys: [
      rows.map((row) =>
        row.original.elements.map(
          (row, index) => row.original.elements[index].value
        )
      ),
    ],
  });
}

fuzzyTextFilterFn.autoRemove = (val) => !val;

const Table = ({ columns, content }) => {
  const filterTypes = React.useMemo(
    () => ({
      fuzzyText: fuzzyTextFilterFn,
    }),
    []
  );

  const defaultColumn = React.useMemo(
    () => ({
      filter: "fuzzyText",
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    state,
    prepareRow,
    setGlobalFilter,
    preFilteredRows,
  } = useTable(
    {
      columns: columns,
      data: content,
      defaultColumn: defaultColumn,
      filters: filterTypes,
      manualFilters: true,
    },
    useFilters,
    useGlobalFilter
  );

  return (
    <div className="flex flex-col min-w-full">
      <GlobalFilter
        preGlobalFilteredRows={preFilteredRows}
        setGlobalFilter={setGlobalFilter}
        globalFilter={state.globalFilter}
      ></GlobalFilter>
      <table {...getTableProps()} className="min-w-full">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr class="text-md tracking-wide text-left text-gray-900 bg-gray-100 uppercase border-b-2 border-gray-600">
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>
                  <div class="flex flex-col items-center justify-center group-hover:text-gray-900 px-3 py-4">
                    {column.render("Header")}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} className="group">
                {row.cells.map((cell) => {
                  return (
                    <td
                      className={`${
                        i !== 1 && i % 2 === 0 ? "bg-gray-300" : ""
                      } text-gray-700 text-center group-hover:bg-gray-600 group-hover:text-gray-900`}
                    >
                      {ReactHtmlParser(cell.value)}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default Table;
